import { render, staticRenderFns } from "./stepsix.vue?vue&type=template&id=4013022a&scoped=true&"
import script from "./stepsix.vue?vue&type=script&lang=js&"
export * from "./stepsix.vue?vue&type=script&lang=js&"
import style0 from "./stepsix.vue?vue&type=style&index=0&id=4013022a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013022a",
  null
  
)

export default component.exports